module.exports = __webpack_public_path__ + "img/141.67727374.jpg";